import { render, staticRenderFns } from "./addAWallet.vue?vue&type=template&id=9f735e40&scoped=true&"
import script from "./addAWallet.vue?vue&type=script&lang=js&"
export * from "./addAWallet.vue?vue&type=script&lang=js&"
import style0 from "./addAWallet.vue?vue&type=style&index=0&id=9f735e40&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f735e40",
  null
  
)

export default component.exports